import { Card, Button } from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IdMP } from "../../../Icons";
import './style.css';
import { useContext } from "react";
import { CadastroContext } from "../../../../contexts/CadastroContext";

const AsoAvisoReconhecimentoFacial = () => {
    const navigate = useNavigate();
    const { cadastro } = useContext(CadastroContext);
    const { dbName, id } = useParams();
    const location = useLocation();

    return (
        <div>
            <Card className="aso-card" style={{ minHeight: 'auto' }}>
                <Card.Body className='aso-card-body'>
                    <div className="icon-text-container d-flex flex-column align-items-center padding">
                        <IdMP height="100px" width="100px" />
                        <Card.Title className='cardTitle text-center'>Para avançarmos, necessitamos apenas de uma foto do seu rosto para reconhecimento facial.</Card.Title>
                        <Card.Text className='cardSubTitle text-center'>Certifique-se de capturar a imagem em um ambiente bem iluminado, evitando acessórios no rosto, e mantendo uma expressão neutra.</Card.Text>
                        <Button variant="primary" className="btn-aso mb-2 mt-2 w-50" onClick={() => navigate(location.pathname === `/aso/registro/aviso-reconhecimento-facial-aso/${dbName}/${id}` && id != null ? `/aso/registro/reconhecimento-facial-aso2/${dbName}/${id}` : `/aso/registro/reconhecimento-facial/${cadastro.idConsulta}/${dbName}/${id}`)}>Continuar</Button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default AsoAvisoReconhecimentoFacial;